import React from 'react'

export const SettingsImageIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='220'
		height='188'
		viewBox='0 0 220 188'>
		<g
			id='Rectangle_257'
			data-name='Rectangle 257'
			fill='#fff'
			stroke='#707070'
			stroke-width='1'>
			<rect width='220' height='188' stroke='none' />
			<rect x='0.5' y='0.5' width='219' height='187' fill='none' />
		</g>
	</svg>
)

export const UploadProfilePictureIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='133'
		height='133'
		className='update-profile-pictureicon-svg'
		viewBox='0 0 133 133'>
		<g id='Group_5005' data-name='Group 5005' transform='translate(-464 -537)'>
			<g
				id='Ellipse_26'
				data-name='Ellipse 26'
				transform='translate(464 537)'
				fill='none'
				stroke='#fff'
				stroke-width='2'>
				<circle cx='66.5' cy='66.5' r='66.5' stroke='none' />
				<circle cx='66.5' cy='66.5' r='65.5' fill='none' />
			</g>
			<circle
				id='Ellipse_27'
				data-name='Ellipse 27'
				cx='60.5'
				cy='60.5'
				r='60.5'
				transform='translate(470 543)'
				fill='#fff'
			/>
			<g id='_1103496' data-name='1103496' transform='translate(505 571)'>
				<path
					id='Path_2830'
					data-name='Path 2830'
					d='M41.373,12.9a16.029,16.029,0,0,0-31.437-.01,11.22,11.22,0,0,0,1.292,22.366h8.014a1.6,1.6,0,1,0,0-3.206H11.228a8.014,8.014,0,1,1,.095-16.029,1.6,1.6,0,0,0,1.593-1.426,12.823,12.823,0,0,1,25.476,0,1.7,1.7,0,0,0,1.688,1.426,8.014,8.014,0,1,1,0,16.029H32.065a1.6,1.6,0,0,0,0,3.206h8.015A11.22,11.22,0,0,0,41.373,12.9Zm0,0'
					transform='translate(0.001 0)'
					fill='#ff3067'
				/>
				<path
					id='Path_2831'
					data-name='Path 2831'
					d='M186.312,201.693a1.6,1.6,0,0,0,2.306-2.227l-.039-.039-6.8-6.8a1.6,1.6,0,0,0-2.267,0l0,0-6.8,6.8a1.6,1.6,0,0,0,2.227,2.306l.039-.039,4.063-4.065V208.7a1.6,1.6,0,1,0,3.205,0V197.628Zm0,0'
					transform='translate(-154.991 -174.878)'
					fill='#ff3067'
				/>
			</g>
			<text
				id='Max_2MB'
				data-name='Max 2MB'
				transform='translate(531 631)'
				fill='#7a719b'
				font-size='15'
				font-family='SegoeUI, Segoe UI'>
				<tspan x='-31.124' y='0'>
					Max 2MB
				</tspan>
			</text>
		</g>
	</svg>
)

export const DarkModeIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='68.679'
		height='72.085'
		className='darkmodeicon-svg'
		viewBox='0 0 68.679 72.085'>
		<g id='moon' transform='translate(-11.598 0)'>
			<path
				id='Path_3369'
				data-name='Path 3369'
				d='M79.8,30.2A36.1,36.1,0,0,0,46.84.006a1.882,1.882,0,0,0-1.613,3.057A29.1,29.1,0,0,1,14.043,49.278,1.882,1.882,0,0,0,11.8,51.914,36.087,36.087,0,0,0,79.8,30.2Z'
				transform='translate(-0.001 0)'
				fill='#fff'
			/>
			<path
				id='Path_3370'
				data-name='Path 3370'
				d='M15.582,58a41.287,41.287,0,0,0,9.465,1.189c20.917.209,38.2-15.281,38.406-34.431.09-8.5-9.05-23.044-9.12-23.391A35.822,35.822,0,0,0,46.839.006a1.882,1.882,0,0,0-1.613,3.057A29.1,29.1,0,0,1,14.042,49.278,1.882,1.882,0,0,0,11.8,51.914,35.877,35.877,0,0,0,15.582,58Z'
				transform='translate(0 0)'
				fill='#fff7db'
			/>
			<path
				id='Path_3371'
				data-name='Path 3371'
				d='M153.35,186.886a9.845,9.845,0,0,1-2.965-2.948.935.935,0,0,0-1.545-.027,12.431,12.431,0,0,1-2.952,2.892.951.951,0,0,0,.045,1.574,9.315,9.315,0,0,1,2.945,2.907.92.92,0,0,0,1.537.009,10.184,10.184,0,0,1,2.942-2.836A.934.934,0,0,0,153.35,186.886Z'
				transform='translate(-114.234 -156.569)'
				fill='#fff'
			/>
			<path
				id='Path_3372'
				data-name='Path 3372'
				d='M30.594,67.758a9.845,9.845,0,0,1-2.965-2.948.935.935,0,0,0-1.545-.027,12.431,12.431,0,0,1-2.952,2.892.951.951,0,0,0,.045,1.574,9.315,9.315,0,0,1,2.945,2.907.92.92,0,0,0,1.537.009A10.184,10.184,0,0,1,30.6,69.328.934.934,0,0,0,30.594,67.758Z'
				transform='translate(-9.503 -54.933)'
				fill='#fff'
			/>
			<g id='Group_4893' data-name='Group 4893'>
				<g
					id='Group_4394'
					data-name='Group 4394'
					transform='translate(33.227 9.874)'>
					<path
						id='Path_3373'
						data-name='Path 3373'
						d='M160,73.563a1.1,1.1,0,0,1-1.1-1.1V68.339a1.1,1.1,0,1,1,2.2,0v4.122A1.1,1.1,0,0,1,160,73.563Z'
						transform='translate(-158.896 -67.238)'
						fill='#fff7db'
					/>
				</g>
				<g
					id='Group_4395'
					data-name='Group 4395'
					transform='translate(31.166 11.935)'>
					<path
						id='Path_3374'
						data-name='Path 3374'
						d='M150.083,83.478h-4.122a1.1,1.1,0,0,1,0-2.2h4.122a1.1,1.1,0,1,1,0,2.2Z'
						transform='translate(-144.86 -81.275)'
						fill='#fff7db'
					/>
				</g>
			</g>
			<g id='Group_4894' data-name='Group 4894'>
				<g
					id='Group_4396'
					data-name='Group 4396'
					transform='translate(16.918 30.25)'>
					<path
						id='Path_3375'
						data-name='Path 3375'
						d='M48.932,212.33a1.1,1.1,0,0,1-1.1-1.1v-4.122a1.1,1.1,0,0,1,2.2,0v4.122A1.1,1.1,0,0,1,48.932,212.33Z'
						transform='translate(-47.831 -206.005)'
						fill='#fff7db'
					/>
				</g>
				<g
					id='Group_4397'
					data-name='Group 4397'
					transform='translate(14.857 32.312)'>
					<path
						id='Path_3376'
						data-name='Path 3376'
						d='M39.018,222.244H34.9a1.1,1.1,0,0,1,0-2.2h4.122a1.1,1.1,0,1,1,0,2.2Z'
						transform='translate(-33.794 -220.041)'
						fill='#fff7db'
					/>
				</g>
			</g>
		</g>
	</svg>
)
